export default {
    metricsDB: {
        name: 'Tablero de Métrica',
        nameOrig: 'Tablero de Métrica (GL)',
        threshold: 'Límite',
        maxCodes: 'Códigos Max',
        maxCodesTT: 'El número máximo de códigos de aplicación para mostrar en el gráfico',
        widgets: {
            frequency: {
                title: 'Endpoints per Frequency',
                subtitle: 'Endpoints on a TBG frequency',
                xAxis: 'Frequency',
                yAxis: 'Number of Endpoints'
            },
            pollResponse: {
                title: 'Endpoints per Poll Response',
                subtitle: 'Endpoints reporting on a TBG frequency',
                xAxis: 'Frequency',
                yAxis: 'Number of Endpoints'
            },
            priority: {
                title: 'Endpoints per Priority',
                subtitle: 'TGBs that are prioritized per endpoint',
                xAxis: 'Frequency',
                yAxis: 'Number of Endpoints'
            },
            downlink: {
                title: 'Endpoints per Downlink',
                subtitle: 'Endpoints that are reporting',
                xAxis: 'Frequency',
                yAxis: 'Number of Endpoints'
            },
            noise: {
                title: 'Más Alto Ruido Ocioso',
                subtitle: 'Endpoints that are reporting',
                baseStationId: 'ID',
                name: 'Nombre',
                noiseHeader: 'Ruido',
                location: 'Locación',
                frequency: 'Frecuencía',
                noisedb: 'Ruido Ocioso (dB)',
                modulation: 'Modulación',
                receivedDate: 'Fecha Recibido',
                minNoise: 'Ruido',
                thresholdTT: 'Ruido inactivo mínimo para el más alto, o ruido inactivo máximo para el más bajo'
            },
            radiosHeard: {
                title: 'Radios escuchados % de cambio (mayor caída reciente)',
                subtitle: 'Endpoints that are reporting',
                baseStationId: 'ID',
                name: 'Nombre',
                radiosHeardHeader: 'Radios escuchados',
                location: 'Locación',
                percentChange: 'Radios escuchados Percent Cambio',
                receivedDate: 'Fecha Recibido',
                TT: "Calculado en los últimos 2 días calendario completos. Negativo indica menos radios que el día anterior. Positivo es más radios. Cero es el mismo número que el día anterior.",
                thresholdTT: 'Minimum percent radios heard for Highest, or maximum percent radios heard for Lowest'
            },
            baseStationLag: {
                title: 'Mayor Retraso de la Estación Base\n',
                subtitle: 'Puntos Finales que Informan',
                baseStationId: 'ID',
                name: 'Nombre',
                baseStationLagHeader: 'Retraso de la Estación Base (ms)',
                location: 'Locación',
                baseStationLag: 'Retraso',
                receivedDate: 'Fecha Recibido',
                minBaseStationLag: 'Retraso Mínimo',
                thresholdTT: 'Retraso mínimo de la estación base para el más alto o retraso máximo de la estación base para el más bajo'
            },
            vswr: {
                title: 'Más Alto VSWR',
                subtitle: 'Endpoints that are reporting',
                baseStationId: 'ID',
                name: 'Nombre',
                vswrHeader: 'VSWR',
                location: 'Locación',
                vswr: 'VSWR',
                receivedDate: 'Fecha Recibido',
                minVswr: 'VSWR',
                thresholdTT: 'VSWR mínimo'
            },
            utilityRis: {
                title: "Leer el éxito del intervalo",
            },
            remoteConnectDisconnectAvgTime: {
                title: "Tiempo de conexión / desconexión remota",
                tooltip: "Tiempo promedio para los comandos de conexión / desconexión remota cuyo ACK se recibe en 30 minutos"
            },
            remoteConnectDisconnectSuccess: {
                title: "Conexión / desconexión remota correcta",
            },
            deviceEsm: {
                title: "Dispositivos ESM"
            },
            baseStationCounts: {
                ackCountsTitle: 'Ack Cuenta',
                buddyMsgsTitle: 'Altos Recuentos de Mensajes de Amigos',
                uniqueBuddyMsgsTitle: 'Altos Mensajes Amigos Unicos',
                dupBuddyMsgsTitle: 'Altos Mensajes Amigos Duplicados',
                transmitCountsTitle: 'Enlace Downlink Comandos Enviados',
                receiveCountsTitle: 'Mensajes Uplink Recibidos',
                commandInCountsTitle: 'Enlace Downlink Comandos Recibidos',
                commandOutCountsTitle: 'Enlace Downlink Comandos En Cola',
                commandOutCountsTT: 'Estación Base ===> Punto Final',
                commandInCountsTT: 'RNI ===> Estación Base',
                transmitCountsTT: 'Estación Base ===> Punto Final',
                receiveCountsTT: 'Estación Base <=== Punto Final',
                thresholdTT: 'Cuenta mínima para la cuenta más alta, o cuenta máxima para la cuenta más baja',
                highestThresholdTT: 'Conteo mínimo',
                highValueTitle: 'Umbral mínimo de conteo',
                lowValueTitle: 'Umbral de conteo máximo',
                highLowTitle: 'Mostrar los conteos de estación base más altos o más bajos',
                name: 'Nombre',
                towerId: 'Nombre',
                noiseHeader: 'Noise',
                location: 'Locación',
                frequency: 'Frecuencía',
                count: 'Contar',
                counts: 'Cuenta',
                modulation: 'Modulación',
                received: 'Fecha Recibido',
                minCounts: 'Cuenta'
            }
        }
    }
}
